import isValidEmail from '../functions/isValidEmail';
import { querySelector } from '../functions/querySelectors';
import {
  FORM_ROW_CLASS,
  FORM_ROW_ERROR_CLASS
} from '../config/main';

const MSG_CLASS = 'form-row__error';
const FILLED_MSG_ATTR = 'data-filled';
const RADIO_CHANGE_INIT_CLASS = 'rcic-init';
const TRANSLATES = {
  default: {
    'cs': 'Vyplňte prosím toto pole.',
    'sk': 'Vyplňte prosím toto pole.',
    'de': 'Bitte füllen Sie dieses Feld aus.'
  },
  email: {
    'cs': 'E-mailová adresa je zadaná ve špatném tvaru.',
    'sk': 'E-mailová adresa je zadaná v zlom tvare.',
    'de': 'Die E-Mail-Adresse ist im falschen Format eingegeben.'
  },
  passLength: {
    'cs': 'Délka hesla musí být 5-15 znaků.',
    'sk': 'Dĺžka hesla musí byť 5-15 znakov.',
    'de': 'Die Länge des Passworts muss 5-15 Zeichen betragen.'
  },
  passMatch: {
    'cs': 'Hesla se neshodují.',
    'sk': 'Heslá sa nezhodujú.',
    'de': 'Passwörter stimmen nicht überein.'
  }
};

let getLang = function() {
  return document.documentElement.getAttribute('lang');
};

let errorMessage = function(item, text) {
  let wrapper = item.parentNode;
  let msg = querySelector(`.${MSG_CLASS}`, wrapper);

  if (msg) {
    if (typeof msg.getAttribute(FILLED_MSG_ATTR) !== 'string') {
      return;
    }
  }

  if (!msg) {
    msg = document.createElement('span');
    msg.classList.add(MSG_CLASS);
    msg.setAttribute(FILLED_MSG_ATTR, '');
    wrapper.appendChild(msg);
  }

  msg.textContent = text;
};

let errorChange = function(event) {
  this.removeEventListener('change', errorChange);
  let row = this.closest(`.${FORM_ROW_CLASS}`);

  row.classList.remove(FORM_ROW_ERROR_CLASS);
};

let checkItem = function(item) {
  let row = item.closest(`.${FORM_ROW_CLASS}`);

  if (item.value === '') {
    row.classList.add(FORM_ROW_ERROR_CLASS);
    errorMessage(item, TRANSLATES.default[getLang()]);
    item.addEventListener('change', errorChange);

    return false;
  }

  if (item.getAttribute('type') && item.getAttribute('type') === 'email') {
    if (!isValidEmail(item.value)) {
      row.classList.add(FORM_ROW_ERROR_CLASS);
      errorMessage(item, TRANSLATES.email[getLang()]);
      item.addEventListener('change', errorChange);

      return false;
    }
  }

  if (item.getAttribute('type') && item.getAttribute('type') === 'password') {
    if (item.value.length < 5 || item.value.length > 15) {
      row.classList.add(FORM_ROW_ERROR_CLASS);
      errorMessage(item, TRANSLATES.passLength[getLang()]);
      item.addEventListener('change', errorChange);

      return false;
    }
  }

  row.classList.remove(FORM_ROW_ERROR_CLASS);
  return true;
};

export function validateForm(items, allow = true) {
  let pass1 = null;
  let pass2 = null;
  let radios = [];

  items.forEach((item) => {
    if (item.getAttribute('type') === 'radio') {
      radios.push(item);
      return;
    }

    if (!checkItem(item)) {
      allow = false;
    }

    if (item.getAttribute('type') && item.getAttribute('type') === 'password') {
      if (!pass1) {
        pass1 = item;
      }
      else {
        pass2 = item;
      }
    }
  });

  if (pass1 && pass2) {
    if (pass1.value !== pass2.value) {
      let row1 = pass1.closest(`.${FORM_ROW_CLASS}`);
      row1.classList.add(FORM_ROW_ERROR_CLASS);
      errorMessage(pass1, TRANSLATES.passMatch[getLang()]);
      pass1.addEventListener('change', errorChange);

      let row2 = pass2.closest(`.${FORM_ROW_CLASS}`);
      row2.classList.add(FORM_ROW_ERROR_CLASS);
      errorMessage(pass2, TRANSLATES.passMatch[getLang()]);
      pass2.addEventListener('change', errorChange);

      allow = false;
    }
  }

  if (radios.length) {
    let names = [];
    let allowedNames = [];

    radios.forEach((radio) => {
      let radioName = radio.getAttribute('name');
      if (names.indexOf(radioName) === -1) {
        names.push(radio);
      }

      if (radio.checked) {
        allowedNames.push(radioName);
      }

      if (!radio.classList.contains(RADIO_CHANGE_INIT_CLASS)) {
        radio.classList.add(RADIO_CHANGE_INIT_CLASS);
        radio.addEventListener('change', errorChange);
      }
    });

    names.forEach((radio) => {
      if (allowedNames.indexOf(radio.getAttribute('name')) === -1) {
        let formRow = radio.closest(`.${FORM_ROW_CLASS}`);
        formRow.classList.add(FORM_ROW_ERROR_CLASS);
      }
    });
  }

  return allow;
}
